export const version = '0.48.0';

// version to update when deploy to QA/test
// futureVersion = '0.48.0'
